import { jsx as _jsx } from "react/jsx-runtime";
import { cleanAction, DBDef_Action } from '@app/pathway-shared';
import { createWorkHubManager } from '@app/styles';
import { ModuleFE_Action } from '../../../_entity.js';
import { OrderItem_EditorRenderer } from '../../Page_OrderEditor/presenters/editor/OrderItem_EditorRenderer.js';
import './Manager_Action.scss';
import { LL_V_L } from '@nu-art/thunderstorm-frontend/index';
const Editor_Action_Wrapper = (props) => _jsx(LL_V_L, { className: 'manager-action', children: _jsx(OrderItem_EditorRenderer, { editable: props.editable, editMode: props.renderArgs.editMode }) });
export const Manager_Action = createWorkHubManager({
    module: ModuleFE_Action,
    dbDef: DBDef_Action,
    defaultItem: cleanAction,
    labelResolver: (item) => item.name ?? 'New Action',
    EditorComponent: Editor_Action_Wrapper,
});
//# sourceMappingURL=Manager_Action.js.map